$(document).ready(function () {
  ("use strict");

  // -------
  // sidenav
  // -------
  if($(".side-nav > li").has("ul").length) {
    $(".side-nav > li").has("ul").append("<span></span>");
  }

  // --------
  // megamenu
  // --------

  // initialize the megamenu
  $("nav:first").accessibleMegaMenu();

  // clicar el botó
  $(".menu-button").on("click", function () {
    $(this).toggleClass("is-active");
    if ($(this).attr("aria-expanded") == "true") {
      $(this).attr("aria-expanded", "false");
    } else {
      $(this).attr("aria-expanded", "true");
    }
  });

  $(".nav-menu a").on("click", function () {
    $(".desplegable button").removeClass("open");
    $(".desplegable ul").attr("aria-hidden", "true");
  });

  // si és touch prevenim click als dropdowns
  if (feature.touch) {
    $("ul.sub-level-group.level-3").hide();
    $(".has-sub-nav > a").on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    });
  }

  if ($(window).width() < 1024) {
    $(".main-nav").attr("aria-hidden", "true");
  }
  $(".menu-button").on("click", function () {
    var atribut = $(".menu-mobil").attr("aria-hidden");

    if (atribut == "true") {
      $(".menu-mobil")
        .attr("aria-hidden", "false")
        .addClass("open");
    } else {
      $(".menu-mobil")
        .attr("aria-hidden", "true")
        .removeClass("open");
    }
  });
  $(window).resize(function () {
    if ($(window).width() > 1023) {
      $(".menu-mobil")
        .attr("aria-hidden", "true")
        .removeClass("open");
      $(".menu-button")
        .attr("aria-expanded", "false")
        .removeClass("is-active");
    }
  });

  $(".main-header .menu").addClass("load");

  // ----------
  // feature.js
  // ----------

  if (feature.svg) {
    $("html").addClass("svg");
  }

  // ------------
  // Match height
  // ------------

  $(".h-news__item").matchHeight();
  $(".caja2").matchHeight();
  $(".caja3").matchHeight();
  $(".h-links a").matchHeight();



  // -----------
  // Collapsible (https://inclusive-components.design/collapsible-sections/)
  // -----------

  if ($(".collapsible")[0]) {
    (function () {
      var headings = document.querySelectorAll('.collapsible > h3');
      Array.prototype.forEach.call(headings, function (h) {
        var btn = h.querySelector('button');
        var target = h.nextElementSibling;

        btn.onclick = function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', !expanded);
          target.hidden = expanded;
        };
      });
    })();
  }



  // -----
  // Popup
  // -----

  $('.popup-with-form').magnificPopup({
    type: 'inline',
    preloader: false,
    focus: '#name',
    closeMarkup: '<button type="button" class="mfp-close"><svg xmlns="http://www.w3.org/2000/svg" width="68" height="68" viewBox="0 0 68 68"><g fill="none" fill- rule="evenodd"><path fill="#ED3854" d="M0 0h68v68H0z"/><path fill="#FFF" fill-rule="nonzero" d="M48 22.82L45.18 20 34 31.18 22.82 20 20 22.82 31.18 34 20 45.18 22.82 48 34 36.82 45.18 48 48 45.18 36.82 34z"/></g></svg></button>',

    // When elemened is focused, some mobile browsers in some cases zoom in
    // It looks not nice, so we disable it:
    callbacks: {
      beforeOpen: function () {
        if ($(window).width() < 700) {
          this.st.focus = false;
        } else {
          this.st.focus = '#nom2';
        }
      }
    }
  });

  // Perquè funcioni el botó de tancar el popup si conté una imatge (https://github.com/dimsemenov/Magnific-Popup/pull/437)
  (function (mfp, PREVENT_CLOSE_CLASS) {

    $.magnificPopup.proto._checkIfClose = function (target) {

      if ($(target).closest('.' + PREVENT_CLOSE_CLASS).length) {
        return;
      }

      var closeOnContent = mfp.st.closeOnContentClick;
      var closeOnBg = mfp.st.closeOnBgClick;

      if (closeOnContent && closeOnBg) {
        return true;
      } else {

        // We close the popup if click is on close button or on preloader. Or if there is no content.
        if (!mfp.content || $(target).closest('.mfp-close').length || (mfp.preloader && target === mfp.preloader[0])) {
          return true;
        }

        // if click is outside the content
        if ((target !== mfp.content[0] && !$.contains(mfp.content[0], target))) {
          if (closeOnBg) {
            // last check, if the clicked element is in DOM, (in case it's removed onclick)
            if ($.contains(document, target)) {
              return true;
            }
          }
        } else if (closeOnContent) {
          return true;
        }

      }
      return false;
    };

  })($.magnificPopup.instance, 'mfp-prevent-close');


  // ------------------------
  // Detect objectFit support (https://codepen.io/pawelgrzybek/pen/Rrybqg)
  // ------------------------
  if ("objectFit" in document.documentElement.style === false) {
    // assign HTMLCollection with parents of images with objectFit to variable
    var container = document.getElementsByClassName("js-of");

    // Loop through HTMLCollection
    for (var i = 0; i < container.length; i++) {
      // Asign image source to variable
      var imageSource = container[i].querySelector("img").src;

      // Hide image
      container[i].querySelector("img").style.display = "none";

      // Add background-size: cover
      container[i].style.backgroundSize = "cover";

      // Add background-image: and put image source here
      container[i].style.backgroundImage = "url(" + imageSource + ")";

      // Add background-position: center center
      container[i].style.backgroundPosition = "center center";
    }
  } else {
    // You don't have to worry
    // console.log("No worries, your browser supports objectFit");
  }

  // ---------
  // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
  // ---------

  // bind a click event to the 'skip' link
  $(".skip-link").click(function (event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = "#" + this.href.split("#")[1];

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo)
      .attr("tabindex", -1)
      .on("blur focusout", function () {
        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr("tabindex");
      })
      .focus(); // focus on the content container
  });

  /*
     * Formulari Dudas
     */
    $(".dudas-form form").submit(function(e){
      e.preventDefault();
      //if ($(this).valid()) {
          $.ajax({
      type: "POST",
      url: $(this).attr('action'),
      data: $(this).serialize(),
        success: function(data) {
          $('.dudas-form .form-content').html(data);
        }
      });

      //}
      return false;
    });

  // -----------------
  // canvi svg per png
  // -----------------

  if (!feature.svg) {
    var imgs = document.getElementsByTagName("img");
    var endsWithDotSvg = /.*\.svg$/;
    var i = 0;
    var l = imgs.length;
    for (; i !== l; ++i) {
      if (imgs[i].src.match(endsWithDotSvg)) {
        imgs[i].src = imgs[i].src.slice(0, -3) + "png";
      }
    }
  }

  // ----------
  // sticky nav
  // ----------
  $(".main-header").headroom();


  // ----------
  // scroll top
  // ----------

  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      $(".top").fadeIn();
    } else {
      $(".top").fadeOut();
    }
  });


  // ------------
  // appendAround
  // ------------
  $(".tools-container-1").appendAround();
  $(".tools-container-2").appendAround();


  // -------------
  // Info claustro
  // -------------

  $(".claustre__cv").before("<button class='claustre__btn'><span class='vh'>CV</span></button>").attr("hidden", "");
  $(".claustre__btn").attr("aria-expanded", "false");
  $(".claustre__btn").on("click", function () {
    // canviar atributs del botó i del cv
    if ($(this).attr("aria-expanded") == "true") {
      $(this)
        .attr("aria-expanded", "false")
      $(this).next().attr("hidden", "");
    } else {
      $(this)
        .attr("aria-expanded", "true")
      $(this).next().removeAttr("hidden");
    }
  });


  // --------
  // Cercador
  // --------

  $(".search-container__panel").before("<button class='search-container__btn' aria-expanded='false'><span class='vh'>Buscar</span></button>").attr("hidden", "");
  $(".search-container__btn").on("click", function () {
    // canviar atributs del botó i del cercador
    if ($(this).attr("aria-expanded") == "true") {
      $(this)
        .attr("aria-expanded", "false")
      $(this).next().attr("hidden", "");
    } else {
      $(this)
        .attr("aria-expanded", "true")
      $(this).next().removeAttr("hidden");
    }
  });


  // ------
  // Slider
  // ------

  $(".slider").slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 10000,
    dots: true,
    appendDots: $('.slider__dots')
  });


  // -------------------------
  // Scroll reveal caixes home
  // -------------------------

  (function ($) {

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

    };

  })(jQuery);

  $(window).fadeIn(function (event) {

    $(".dades__wrapper").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("fadeIn");
      } else {
        el.removeClass("fadeIn");
      }
    });

  });

  // ----
  // Tabs https://inclusive-components.design/tabbed-interfaces/
  // ----

  if ($(".tabbed").length > 0) {

    (function () {
      // Get relevant elements and collections
      var tabbed = document.querySelector('.tabbed');
      var tablist = tabbed.querySelector('ul');
      var tabs = tablist.querySelectorAll('a');
      var panels = tabbed.querySelectorAll('.panel');

      // The tab switching function
      var switchTab = function switchTab(oldTab, newTab) {
        newTab.focus(); // Make the active tab focusable by the user (Tab key)

        newTab.removeAttribute('tabindex'); // Set the selected state

        newTab.setAttribute('aria-selected', 'true');
        oldTab.removeAttribute('aria-selected');
        oldTab.setAttribute('tabindex', '-1'); // Get the indices of the new and old tabs to find the correct
        // tab panels to show and hide

        var index = Array.prototype.indexOf.call(tabs, newTab);
        var oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
        panels[oldIndex].hidden = true;
        panels[index].hidden = false;
      }; // Add the tablist role to the first <ul> in the .tabbed container


      tablist.setAttribute('role', 'tablist'); // Add semantics are remove user focusability for each tab

      Array.prototype.forEach.call(tabs, function (tab, i) {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('id', 'tab' + (i + 1));
        tab.setAttribute('tabindex', '-1');
        tab.parentNode.setAttribute('role', 'presentation'); // Handle clicking of tabs for mouse users

        tab.addEventListener('click', function (e) {
          e.preventDefault();
          var currentTab = tablist.querySelector('[aria-selected]');

          if (e.currentTarget !== currentTab) {
            switchTab(currentTab, e.currentTarget);
          }
        }); // Handle keydown events for keyboard users

        tab.addEventListener('keydown', function (e) {
          // Get the index of the current tab in the tabs node list
          var index = Array.prototype.indexOf.call(tabs, e.currentTarget); // Work out which key the user is pressing and
          // Calculate the new tab's index where appropriate

          var dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;

          if (dir !== null) {
            e.preventDefault(); // If the down key is pressed, move focus to the open panel,
            // otherwise switch to the adjacent tab

            dir === 'down' ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
          }
        });
      }); // Add tab panel semantics and hide them all

      Array.prototype.forEach.call(panels, function (panel, i) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '-1');
        var id = panel.getAttribute('id');
        panel.setAttribute('aria-labelledby', tabs[i].id);
        panel.hidden = true;
      }); // Initially activate the first tab and reveal the first tab panel

      tabs[0].removeAttribute('tabindex');
      tabs[0].setAttribute('aria-selected', 'true');
      panels[0].hidden = false;

      // TODO: mostrar el tab seleccionat que correspongui quan provens d'un enllaç
      var hash = window.location.hash;
      if (hash != '') {
        if ($('.tab-menu li [href="' + hash + '"]').length > 0) {
            var currentTab = tablist.querySelector('[aria-selected]');
            switchTab(currentTab, tablist.querySelector('[href="' + hash + '"]'));
        }
      }
    })();
  }

  
});